"use strict";
exports.__esModule = true;
exports.TableChartComponent = exports.chartOptions = void 0;
var angular = require("angular");
var addTablePy_1 = require("../../widgets/action/add-tables/app/js/logic/addTablePy");
var graphicsAdapters_1 = require("../../widgets/action/add-tables/app/js/logic/graphicsAdapters");
require('./table-chart.component.css');
var COMPONENT_NAME = 'smartorg.r6.cmpts.tableChart';
exports.chartOptions = {
    chartBy: { ROW: 'row', COL: 'col' },
    type: { LINE: 'line', BAR: 'bar' },
    orientation: { HORIZONTAL: 'horizontal', VERTICAL: 'vertical' }
};
var TableChartComponent = /** @class */ (function () {
    function TableChartComponent($timeout) {
        this.chartOptions = exports.chartOptions;
        this.$timeout = $timeout;
        // Default setting
        this.chartType = this.chartOptions.type.LINE;
        this.orientation = this.chartOptions.orientation.HORIZONTAL;
    }
    TableChartComponent.prototype.$onChanges = function (changes) {
        var _this = this;
        this.plotElementId = "table-chart-plot-area-" + this.chartId;
        if (changes.chartConfig) {
            this.setDefaultDisplay();
        }
        if ((changes.chartBy || changes.tableData) && this.tableData) {
            this.applyChartRules();
            // Process render otherwise Highcharts cannot see element to plot.
            this.$timeout(function () {
                _this.updateDefaultDisplay();
                _this.drawChart();
            });
        }
    };
    TableChartComponent.prototype.applyChartRules = function () {
        if (this.chartBy === this.chartOptions.chartBy.COL || !this.chartConfig || !this.chartConfig.isPnl) {
            this.chartType = this.chartOptions.type.BAR;
        }
        else {
            this.chartType = this.chartOptions.type.LINE;
        }
    };
    TableChartComponent.prototype.setDefaultDisplay = function () {
        if (this.chartConfig.defaultDisplay) {
            this.chartType = this.chartConfig.defaultDisplay.chartType || this.chartType;
            this.orientation = this.chartConfig.defaultDisplay.orientation || this.orientation;
            this.chartBy = this.chartConfig.defaultDisplay.chartBy;
        }
    };
    TableChartComponent.prototype.filterTableData = function (tableData) {
        for (var i = 0; i < tableData.length; i++) {
            var row = tableData[i];
            for (var j = 1; j < row.length; j++) {
                // starting loop from 1, to leave first cell (header)
                if (typeof row[j] === 'string') {
                    var numberValue = Number(row[j]);
                    if (!isNaN(numberValue)) {
                        row[j] = numberValue; // Update the value in the original array
                    }
                    else {
                        row[j] = 0; // Convert invalid numeric strings to an empty string
                    }
                }
            }
        }
        return tableData;
    };
    TableChartComponent.prototype.drawChart = function () {
        var _a = this.tableData.table, tableName = _a.tableName, tableData = _a.tableData;
        tableData = this.filterTableData(tableData);
        var chartMatrix = new addTablePy_1.Matrix(tableData).trimEmptyCols().trimEmptyRows();
        if (this.chartConfig.ignoredCols) {
            chartMatrix = chartMatrix.withoutRows(this.chartConfig.ignoredCols);
        }
        if (this.chartBy === this.chartOptions.chartBy.ROW) {
            chartMatrix = chartMatrix.transpose();
        }
        var chartTitle = this.chartName + " for " + tableName;
        var _b = this.chartConfig, chartSettings = _b.chartSettings, timestamp = _b.timestamp;
        var graphAdapter = new graphicsAdapters_1.HighCharts(this.chartType, chartTitle, chartSettings, timestamp);
        graphAdapter.setup(chartMatrix.data, this.orientation);
        graphAdapter.setUseOffsetWidth(true);
        graphAdapter.setType(this.chartType, this.orientation);
        graphAdapter.drawOn(this.plotElementId, null);
    };
    TableChartComponent.prototype.updateDefaultDisplay = function () {
        if (this.updateDefault) {
            var newConfig = {
                chartBy: this.chartBy,
                chartType: this.chartType,
                orientation: this.orientation
            };
            this.updateDefault({ newConfig: newConfig });
        }
    };
    TableChartComponent.prototype.toggleChartType = function (newType) {
        this.chartType = newType;
        this.updateDefaultDisplay();
        this.drawChart();
    };
    TableChartComponent.prototype.rotateChart = function (newOrientation) {
        this.orientation = newOrientation;
        this.updateDefaultDisplay();
        this.drawChart();
    };
    return TableChartComponent;
}());
exports.TableChartComponent = TableChartComponent;
angular.module(COMPONENT_NAME, []).component('tableChart', {
    template: require('./table-chart.component.html'),
    bindings: {
        chartId: '@',
        chartBy: '<',
        chartName: '<',
        tableData: '<',
        chartConfig: '<',
        updateDefault: '&?'
    },
    controller: TableChartComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=table-chart.component.js.map


// WEBPACK FOOTER //
// ./app/components/table-chart/table-chart.component.js